import { render } from "./UpSaleComponent.vue?vue&type=template&id=7b23c97c&ts=true"
import script from "./UpSaleComponent?vue&type=script&lang=ts"
export * from "./UpSaleComponent?vue&type=script&lang=ts"
/* custom blocks */
import block0 from "./_assets/_UpsaleComponent.scss?vue&type=custom&index=0&blockType=styles&issuerPath=%2Fhome%2Frunner%2Fwork%2Fatlantis%2Fatlantis%2Fsrc%2Fviews%2Fcalculators%2Fcomponents%2FUpSaleComponent%2FUpSaleComponent.vue&lang=scss"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__